define('pwa/view/module/network-status/NetworkStatusView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * @class NetworkStatusView
     */
    return LayoutView.extend({

        template: '#network_status_view',

        ui: {
            tryAgain: '#sb_network_status_try_again',
        },

        events: {
            'click @ui.tryAgain': 'onTryAgain',
        },

        modelEvents: {
            'change': 'render',
        },

        onTryAgain: function () {
            window.location.reload()
        },
    });

});
